import { Site } from '../models/site.model';
import { User } from '../models/user.model';

export function isSiteActive(site: Pick<Site, 'activationStatus'> | null | undefined): boolean {
  return site?.activationStatus !== 'pending';
}

export function hasApplicationAccess(user: Pick<User, 'accountAccessStatus'> | null | undefined): boolean {
  return user?.accountAccessStatus !== 'pending-site-activation';
}
